import { createAction } from '@reduxjs/toolkit';
import { ConversationFormValues } from 'lib-shared-legacy-types';
import { createActions } from 'redux-actions';

export const actions = Object.assign(
  createActions(
    {},

    'CONVERSATIONS_INCREASING_UNREAD',
    'CONVERSATIONS_RESET_UNREAD',

    'CONVERSATIONS_ADD',
    'CONVERSATIONS_REMOVE',

    'CONVERSATIONS_UPDATE_USER',
    'CONVERSATIONS_UNASSIGN_SELF',
    'CONVERSATIONS_SAVE_TEMP_MESSAGE',
    'CONVERSATIONS_SAVE_TEMP_WRAPUP',
    'CONVERSATIONS_CLOSE_CONVERSATION',
    'CONVERSATIONS_CONVERSATION_TO_PENDING',
    'CONVERSATIONS_CONVERSATION_CANCEL_PENDING',
    'CONVERSATIONS_CONVERSATION_OFFER_ACCEPTED',
    'CONVERSATIONS_CONVERSATION_CLAIMED',
    'CONVERSATIONS_CONVERSATION_TRANSFERED',
    'CONVERSATIONS_CONVERSATION_ASSISTED_TRANSFER_ACCEPTED',
    'CONVERSATIONS_UPDATE',
    'CONVERSATIONS_SET',
    'SYNC_SIDEBAR_CONVERSATIONS',
    'CONVERSATIONS_CONVERSATION_CHANNEL_CHANGED',
  ),
  {
    conversationsSaveTempFormValues: createAction<{
      csid: number;
      formValues: ConversationFormValues;
    }>('conversations/saveTempFormValues'),
  },
);
